(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const isHome = document.body.classList.contains('kg-site--index');
  if (isHome) return;

  let observer;

  const animateHeading = (heading) => {
    if (!heading || heading.dataset.kgTextAnimated === 'true') return;
    heading.dataset.kgTextAnimated = 'true';

    const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) {
      if (walker.currentNode.textContent.trim()) textNodes.push(walker.currentNode);
    }

    let wordIndex = 0;
    textNodes.forEach((node) => {
      const fragment = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach((part) => {
        if (!part || /^\s+$/.test(part)) {
          fragment.appendChild(document.createTextNode(part));
          return;
        }
        const span = document.createElement('span');
        span.className = 'kg-word';
        span.style.setProperty('--kg-word-delay', `${Math.min(90 + wordIndex * 70, 650)}ms`);
        span.textContent = part;
        fragment.appendChild(span);
        wordIndex += 1;
      });
      node.replaceWith(fragment);
    });

    requestAnimationFrame(() => heading.classList.add('kg-text-ready'));
  };

  const observeElements = (scope = document) => {
    const selectors = [
      '#MainContent > .shopify-section > *',
      '.product-grid > .grid__item',
      '.collection-list > .grid__item',
      '.blog-articles > .blog-articles__article',
      '.product__media-wrapper',
      '.product__info-wrapper',
      '.facets-container',
      '.article-template__content',
      '.kg-template--contact .multicolumn-list__item',
    ];

    const elements = scope.querySelectorAll?.(selectors.join(',')) || [];
    elements.forEach((element, index) => {
      if (element.dataset.kgReveal === 'true') return;
      element.dataset.kgReveal = 'true';
      element.classList.add('kg-site-reveal');
      element.style.setProperty('--kg-delay', `${Math.min((index % 4) * 85, 255)}ms`);
      if (reducedMotion.matches || !observer) element.classList.add('kg-is-visible');
      else observer.observe(element);
    });

    scope.querySelectorAll?.('#MainContent h1, #MainContent .product__title h1, .kg-template--about-us #MainContent .banner__heading, .kg-template--about-us #MainContent .multicolumn-card h3, .kg-template--contact #MainContent .banner__heading, .kg-template--contact #MainContent .multicolumn-card h3, .kg-template--contact #MainContent .contact__aside .title')?.forEach(animateHeading);

  };

  const init = () => {
    document.body.classList.add('kg-motion-ready');

    if (!reducedMotion.matches && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('kg-is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: .08, rootMargin: '0px 0px -6% 0px' });
    }

    const progress = document.createElement('div');
    progress.className = 'kg-scroll-progress';
    progress.setAttribute('aria-hidden', 'true');
    progress.innerHTML = '<span></span>';
    document.body.appendChild(progress);
    const progressBar = progress.firstElementChild;
    let frame = 0;

    const updateProgress = () => {
      frame = 0;
      const travel = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      progressBar.style.transform = `scaleX(${Math.min(Math.max(window.scrollY / travel, 0), 1)})`;
    };
    window.addEventListener('scroll', () => {
      if (!frame) frame = requestAnimationFrame(updateProgress);
    }, { passive: true });
    updateProgress();

    observeElements(document);

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) observeElements(node);
      }));
    });
    mutationObserver.observe(document.getElementById('MainContent'), { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => observeElements(event.target));
})();
